import React, {useContext} from "react";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {DateTime} from "luxon";
import {hasAnomalia, hasWarning} from "../../pianificazione/comps/BannerDay";
import classNames from "classnames";
import {PresenzeContext} from "@commons/hooks/usePresenze";
import {PageType} from "../../dashboardWF/wf.dashboard.detail";
import {FPNetDate} from "@commons/types";

interface CalendarProps {
    mese: number,
    days: PresenzeGiornataPlusRecord[] | null,
    onClickDay: () => void,
    dtGiornata: FPNetDate,
}

const Calendar: React.FC<CalendarProps> = ({mese, days, onClickDay, dtGiornata}) => {
    const {selectGiornata} = useContext(PresenzeContext);

    const getColorGiornata = (page: PageType, anomalia: number, warning: number, warningChecked: number) => {
        if (page === 'Presenze') {
            if (hasAnomalia(anomalia)) {
                switch (anomalia) {
                    case -3:
                        return 'border-t-daCalcolare';
                    default:
                        return 'border-t-bgAnomalia text-black';
                }
            }
            if (hasWarning(warning, warningChecked)) {
                return 'border-t-warning';
            }
            if (!hasAnomalia(anomalia) && !hasWarning(warning, warningChecked)) {
                return 'border-t-ggQuadrata';
            }
        } else return 'border-t-gray-100'
    }

    return <>
        {days && <div className="flex gap-x-1 pb-2 overflow-x-auto whitespace-nowrap thinScrollbar max-w-fit mx-auto my-2">
            {days.map(day => {

                const giornoDt = DateTime.fromISO(day.dtGiornata!)
                const selectedMonth = parseInt(giornoDt.toFormat("LL"));

                return <button key={day.dtGiornata}
                               onClick={() => {
                                   onClickDay();
                                   selectGiornata(day);
                               }}
                               className={classNames('group flex flex-col border-t-4 pt-1.5 pl-2 pr-1 max-w-10',
                                   dtGiornata === day.dtGiornata ? 'border-t-sky-200 bg-sky-200 rounded-b-[2px]' : getColorGiornata('Presenze', day.anomalia, day.warning, day.warningChecked))}>
                    {/*
                            N.B. per la giornata selezionata, evito di indicare il colore dello stato della stessa (in anomalia o warning),
                            in quanto tale stato potrebbe variare in base alle azioni sul form e verrebbe aggiornato solo dopo il calcolo o il consolidamento della giornata stessa.
*/}
                    <span className="text-xs font-medium group-hover:text-gray-400 max-w-[38px]">
                                {mese === selectedMonth && giornoDt.toFormat("dd")}
                        {mese !== selectedMonth && giornoDt.toFormat("dd/LL")}
                            </span>
                </button>
            })}

        </div>
        }

        {!days && <div className="text-xs font-medium italic text-blue-500 text-center my-2.5">Anteprima calendario mensile non disponibile!</div>}
    </>
}

export default Calendar;